module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.73572","quantity":0.00736},{"color":"#9dc4b5","label":" 0.73572- 3.78714","quantity":0.03787},{"color":"#e6efc3","label":" 3.78714- 5.10254","quantity":0.05103},{"color":"#ffe89e","label":" 5.10254- 6.59479","quantity":0.06595},{"color":"#f5af7f","label":" 6.59479- 8.77404","quantity":0.08774},{"color":"#ed6d32","label":" 8.77404- 25.57425","quantity":0.25574}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/cfxssl_raster/wheat_MME_1981_2016_lcr_100.json
// module id = jPg+
// module chunks = 171